import React from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import { fundedTraderActions } from "../../../../reducers/fundedTrader";
import { APIFunds } from "../../../../api";
const PriorityStatusControls = (): React.ReactElement => {
  const dispatch = useDispatch();

  const { accounts_id, is_priority_to_process, isLoading } = useSelector(
    (state) => state.fundedTrader
  );

  const handleChangePriorityProcess = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      dispatch(fundedTraderActions.dataFetchRequest());
      const response = await APIFunds.updateFundedTraderDataRequest(accounts_id, {
        is_priority_to_process: event.target.checked,
      });
      dispatch(fundedTraderActions.dataFetchSuccess(response.data));
    } catch (error) {
      console.error("Error handle change priority process", error);
      dispatch(fundedTraderActions.dataFetchFailed());
    }
  };

  return (
    <FormControlLabel
      label="Priority to process"
      control={
        <Checkbox
          size="small"
          disabled={isLoading}
          checked={is_priority_to_process}
          onChange={handleChangePriorityProcess}
        />
      }
    />
  );
};

export default PriorityStatusControls;
